let items = [];

// Valid Tags
// all
// general
// stats
// account
// social

items[1] = {
    'id' : 1,
    'question' : 'I have been blocked from my account, please help!',
    'answer' : 'If you have been prevented from logging in this may be due to secuirity concerns. We recommend you change your password or contact us at statherohelp@gmail.com.',
    'tags' : ['all', 'account']
};

items[2] = {
    'id' : 2,
    'question' : 'Where can I interact with other people from the StatHero community?',
    'answer' : 'We have multiple different social media account where you can find like minded people and fellow StatHero and football enthusiasts! Check out our contact page or just search for StatHero on your favourite social media website. ',
    'tags' : ['all', 'social', 'general']
};

items[3] = {
    'id' : 3,
    'question' : 'How do I create a new account?',
    'answer' : 'Simply navigate to the top right corner of the page and press the sign up button. From there just follow the instructions and you will be part of our community in no time!',
    'tags' : ['all', 'account']
};

items[4] = {
    'id' : 4,
    'question' : 'How can I learn more about what StatHero offers?',
    'answer' : 'Our about section can help to explain the key aspects of our site. If you prefer to learn another way then we are happy to answer questions on social media or by email.',
    'tags' : ['all', 'general', 'social']
};

items[5] = {
    'id' : 5,
    'question' : 'How do I gain access to the private Facebook group?',
    'answer' : 'This group is for our top statters! We use it to learn more about our members and improve our service. Simply contact us via social media or email to request to join! ',
    'tags' : ['all', 'general', 'social']
};

items[6] = {
    'id' : 6,
    'question' : 'Are you active on social media? If so where can I find you?',
    'answer' : 'We are very active across all social media! Facebook, Instagram and Twitter are our main accounts, use the contact page to find us.',
    'tags' : ['all', 'social']
};

items[7] = {
    'id' : 7,
    'question' : 'I am confused about how to use the stats page! Do you have any tutorials or help pages?',
    'answer' : 'At the moment we do not have any tutorials but we will soon! In the meantime please feel free to contact us and we will be happy to walk you through it all.',
    'tags' : ['all', 'stats']
};

items[8] = {
    'id' : 8,
    'question' : 'How often are the stats updated?',
    'answer' : 'At the moment we update them every 3 months however we are working very hard behind the scenes to reduce this time and hope for it to be closer to 2 weeks in the near future!',
    'tags' : ['all', 'stats']
};

export default items;
